import React, { useEffect, useState,useRef } from "react";
import UAParser from "ua-parser-js";
import UKMapWithMarkers from "./Maps";

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';


import {
  Button,
  Typography,
  Box,
  Grid,
  Autocomplete,
  createFilterOptions,
  TextField,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Container,
  Skeleton,
  Chip,
  Alert,
  AlertTitle,
  colors,
  CircularProgress,
  Backdrop,
  Paper,
  FormControl,
  Divider,
  Link,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { Clear, Info } from "@mui/icons-material";
import ReCAPTCHA from "react-google-recaptcha";
import { useDebounce } from "use-debounce";
import LocationOffTwoTone from "@mui/icons-material/LocationOffTwoTone";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { Store, Storefront, ViewComfyAltRounded } from "@mui/icons-material";
import { LocationOn } from "@mui/icons-material";
import { Info as InfoIcon } from "@mui/icons-material";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { getStoreNames } from "../services/Store.Service";
import PhoneIcon from "@mui/icons-material/Phone"; //
import StoreIcon from '@mui/icons-material/Store';
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import PlumbingIcon from "@mui/icons-material/Plumbing";
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { GetAll_Service_SubStypes } from "../services/Service.Service";
import { GetStoreAvailableData } from "../services/Store.Service";
import { getAppointmentSlot } from "../services/Store.Service";
import { createAppointment } from "../services/Store.Service";
import { authService } from "../services/auth.service";
import bannerImage from "../assets/images/CustomFit.jpg";
import { ArrowRight } from "@mui/icons-material";
import { GolfCourse } from "@mui/icons-material";
import { UpsertCustomer } from "../services/Customer.Service";
import { SearchCustomer } from "../services/Customer.Service";
import { createKnownCustomerAppointment } from "../services/Store.Service";
import PlaceIcon from '@mui/icons-material/LocationOn';
import {
  ValidateEmail_Experian,
  searchAddressByKeyWord,
  getExperianConfig,
  getIndvidual_Experian,
  getExperianPhoneValid,
  Verify_Captcha,
  CheckCustomerDataCommerceTool,
  AddCustomerDataCommerceTool
} from "../services/Configuration.Service";
import EmailTwoToneIcon from "@mui/icons-material/EmailTwoTone";
import MarkEmailReadTwoToneIcon from "@mui/icons-material/MarkEmailReadTwoTone";
import SystemSecurityUpdateGoodTwoToneIcon from "@mui/icons-material/SystemSecurityUpdateGoodTwoTone";
import WhereToVoteTwoToneIcon from "@mui/icons-material/WhereToVoteTwoTone";
import LocationOnTwoToneIcon from "@mui/icons-material/LocationOnTwoTone";
import { getcountryByName, experianConfig } from "./utils";
import FirebaseLogger from "../services/firebaseanalytics.service";
import TagManager from "react-gtm-module";
import LocationOnIcon from '@mui/icons-material/LocationOn';

export default function BookingsV3_2() {
  const [openMap, setOpenMap] = useState(false)
  const [newSlots, setNewSlots] = useState([])
  const firebaseLogger = new FirebaseLogger();
  const [activeStep, setActiveStep] = useState(0);
  const [storeList, setStoreList] = useState([]);
  const [SelectedStore, setSelectedStore] = useState(null);
  const [newSelectedStore, setNewSelectedStore] = useState(null);
  const [StoreDetails, setStoreDetails] = useState(null);
  const [SelectedService, setSelectedService] = useState(null);
  const [SelectedSubService, setSelectedSubService] = useState(null);
  const [ServiceList, setServiceList] = useState([]);

  const [SelectedDate, setSelectedDate] = useState(dayjs());
  const [availableDates, setAvailableDates] = useState(null);
  const [TImeLoading, setTimeLoading] = useState(false);
  const [AvailableTimeslot, setAvailableTimeSlots] = useState([]);
  const [SelectedTime, setSelectedTime] = useState(null);
  const [newSelectedTime, setNewSelectedTime] = useState(null);

  const [Title, setTitle] = useState("");
  const [TitleName, setTitleName] = useState("");
  const [Firstname, setFirstName] = useState("");
  const [Lastname, setlastName] = useState("");
  const [Dob, setDob] = useState(null);
  const [Email, setEmail] = useState("");
  const [AddressLine1, setAddressLine1] = useState("");
  const [AddressLine2, setAddressLine2] = useState("");
  const [AddressLine3, setAddressLine3] = useState("");
  const [City, setCity] = useState("");
  const [Country, setCountry] = useState("");
  const [PostalCode, setPostalCode] = useState("");
  const [Mobile, setMobile] = useState(null);
  const [TeleAlert, setTeleAlert] = useState(false);
  const [MailAlert, setMailAlert] = useState(false);
  const [SmsAlert, setSmSAlert] = useState(false);
  const [EmailAlert, setEmailAlert] = useState(false);
  const [StoreUnAvailability, setStoreUnAvailability] = useState([]);
  const [StoreHolidays, setStoreHolidays] = useState([]);
  const [DisbaledDates, setDisbaledDates] = useState([]);
  const [CalendarLoading, setCalendarLoading] = useState(false);
  const [AppointmentConfirmed, setAppointmentConfirmed] = useState(false);
  const [Datasubmit, setDatasubmit] = useState(true);
  const [loadService, setLoadService] = useState(false)
  const [appointmentCode, setAppointmentcode] = useState("");
  const [SearchCusId, setSearchCusId] = useState(null);
  const [Userid, setUserId] = useState(0);

  const [ErrorList, setErrorList] = useState([]);

  const [saveWarning, setSaveWarning] = useState(false);

  const [loadNewSlot,setLoadNewSlot] = useState(false);

  const [focused, setFocused] = useState(false);


  useEffect(() => {
    setSearchCusId(null);
    getStoreData();
    // getServiceData();

    let key = process.env.REACT_APP_GTM_KEY;

    firebaseLogger.logInfo("WB_landed", {
      pageEvent: "User landed in webbooking portal",
    });
    const tagManagerArgs = {
      gtmId: key,
    };
    if (key) {
      TagManager.initialize(tagManagerArgs);
    }
  }, []);

  useEffect(() => {
    const newStartDate = moment().startOf("month");
    const newEndDate = moment().endOf("month");
    if (SelectedStore != null) {
      getAvailableDate();
    }
    console.log("SelectedStore", SelectedStore)
  }, [SelectedStore]);

  useEffect(() => {
    getTimeSlots();
  }, [SelectedDate]);

  /// code to get the store list
  const getStoreData = async () => {
    try {
      var res = await getStoreNames();
      if (res.isSuccess == true && res.statusCode == 200) {
        let openStores = res.result.filter((each) => each.STATUS == true) ?? [];
        openStores = openStores.map(store => {
          const parts = store?.Location?.split(',').map(p => p.trim());
          return {
            ...store,
            CityAddress: parts?.slice(-3).join(', ') || null,
            Location: parts?.slice(0, -3).join(', ') || null
          };
        });
        console.log("openStores", openStores);
        setStoreList(openStores);
        
    //     setStoreList([    {
    //   Id: 298,
    //   STATUS: true,
    //   StoreCode: "S030",
    //   StoreName: "Aberdeen",
    //   lat: 57.1497,
    //   lng: -2.0943,
    //   phone: "+44 1224 000000",
    //   location: "Aberdeen, Scotland",
    // },
    // {
    //   Id: 299,
    //   STATUS: true,
    //   StoreCode: "S031",
    //   StoreName: "Edinburgh",
    //   lat: 55.9533,
    //   lng: -3.1883,
    //   phone: "+44 131 000000",
    //   location: "Edinburgh, Scotland",
    // },
    // {
    //   Id: 300,
    //   STATUS: true,
    //   StoreCode: "S032",
    //   StoreName: "Glasgow",
    //   lat: 55.8642,
    //   lng: -4.2518,
    //   phone: "+44 141 000000",
    //   location: "Glasgow, Scotland",
    // }])
        firebaseLogger.logInfo("WB_store_data_pass", {
          response: JSON.stringify(res),
        });
      } else {
        firebaseLogger.logWarning("WB_store_data_warn", {
          response: JSON.stringify(res),
        });
        toast.warn(res.message);
      }
    } catch (error) {
      firebaseLogger.logError("WB_store_data_fail", {
        errorDetails: JSON.stringify(error),
      });
      toast.warn("Something went wrong");
    }
    finally{
      setDatasubmit(false);
    }
  };

  /// code to get the service types

  const getServiceData = async (storeId) => {
    try {
      setLoadService(true)
      var res = await GetAll_Service_SubStypes(storeId);
      if (res.isSuccess == true && res.statusCode == 200) {
        console.log(
          res.result.resultSet.filter(
            (item) => item.SubServiceName != "Generic" && item.status != false
          )
        );
        setServiceList(
          res.result.resultSet.filter(
            (item) => item.SubServiceName != "Generic" && item.status != false
          )
        );
        firebaseLogger.logInfo("WB_svc_data_pass", {
          response: JSON.stringify(res),
        });
      } else {
        firebaseLogger.logWarning("WB_svc_data_warn", {
          response: JSON.stringify(res),
        });
        toast.warn(res.message);
      }
    } catch (error) {
      firebaseLogger.logError("WB_svc_data_fail", {
        errorDetails: JSON.stringify(error),
      });
      toast.warn("Something went wrong");
    } finally {
      setDatasubmit(false);
      setLoadService(false)
    }
  };
  // code to get the available dates
  const getAvailableDate = async (start, end) => {
    var UnAvailableDays = [];
    setStoreUnAvailability([]);
    setDisbaledDates([]);

    try {
      var response = await GetStoreAvailableData(SelectedStore?.Id);

      if (response.isSuccess == true) {
        setStoreDetails(response.result);
        setStoreUnAvailability(response?.result?.StoreAvailability);
        dateCalculations(response?.result?.StoreHolidays ?? []);
        // setStoreHolidays(response?.result?.StoreHolidays);
        firebaseLogger.logInfo("WB_store_avail_pass", {
          response: JSON.stringify(response),
        });
      } else {
        firebaseLogger.logWarning("WB_store_avail_warn", {
          response: JSON.stringify(response),
        });
      }
      console.log(UnAvailableDays);
    } catch (error) {
      firebaseLogger.logError("WB_store_avail_fail", {
        errorDetails: JSON.stringify(error),
      });
      console.log(error);
      toast.warn("Something went wrong");
    }
  };

  const dateCalculations = (holidays) => {
    const generateDates = (holidayFrom, holidayTo) => {
      const startDate = dayjs(holidayFrom);
      const endDate = dayjs(holidayTo);
      const dates = [];

      for (
        let date = startDate;
        date.isBefore(endDate) || date.isSame(endDate);
        date = date.add(1, "day")
      ) {
        dates.push(date.format("YYYY-MM-DD"));
      }

      return dates;
    };

    const uniqueDates = new Set();

    holidays.forEach((holiday) => {
      const dates = generateDates(holiday.holidayFrom, holiday.holidayTo);
      dates.forEach((date) => uniqueDates.add(date));
    });

    const sortedUniqueDates = Array.from(uniqueDates).sort();
    setStoreHolidays(sortedUniqueDates);
  };

  const getDisabledDates = async (
    UnAvailableDays,
    startOfMonth,
    endOfMonth
  ) => {
    try {
      setDisbaledDates([]);
      setCalendarLoading(true);
      const dates = [];
      const startDate = startOfMonth;
      const endDate = endOfMonth;

      const weekdayIndices = UnAvailableDays.map((weekday) =>
        moment().day(weekday).day()
      );

      var current = moment(startDate).startOf("week");

      while (current.isSameOrBefore(endDate)) {
        const dayOfWeek = current.day();

        if (weekdayIndices.includes(dayOfWeek)) {
          dates.push(current.format("DD-MMM-YYYY"));
        }
        current.add(1, "day");
      }

      setDisbaledDates(dates);

      setTimeout(() => {
        setCalendarLoading(false);
      }, 200);
    } catch (error) {}
  };

  const isDateDisabled = (date) => {
    return DisbaledDates.some((disabledDate) =>
      date.isSame(moment(disabledDate), "day")
    );
  };

  // to get the appointment time slots

  const getTimeSlots = async (setNewSlotState, storeId, newSlotSelected) => {
    if(setNewSlotState){
      setLoadNewSlot(true)
    }
    else {
      setTimeLoading(true);
      setAvailableTimeSlots([]);
    }

    try {
      if (
        SelectedDate != null &&
        SelectedSubService?.SubServiceTypeId &&
        SelectedStore?.Id
      ) {
        var response = await getAppointmentSlot(
          SelectedSubService?.SubServiceTypeId,
          storeId || SelectedStore?.Id,
          SelectedDate?.format("YYYY-MM-DD")
        );
        var slots = [];
        if (response?.isSuccess == true) {
          response.result.forEach((element) => {
            let concatTime =
              moment(element?.availableSlotFrom, [
                "HH:mm:ss",
                "h:mm:ss A",
                "h:mm:ss a",
              ]).format("HH:mm") +
              "-" +
              moment(element?.availableSlotTo, [
                "HH:mm:ss",
                "h:mm:ss A",
                "h:mm:ss a",
              ]).format("HH:mm");

            if (
              SelectedDate.format("YYYY-MM-DD") != moment().format("YYYY-MM-DD")
            ) {
              slots.push(concatTime);
            } else if (
              SelectedDate.format("YYYY-MM-DD") ==
                moment().format("YYYY-MM-DD") &&
              moment() <
                moment(element?.availableSlotTo, [
                  "HH:mm:ss",
                  "h:mm:ss A",
                  "h:mm:ss a",
                ])
            ) {
              slots.push(concatTime);
            }
          });
          if(setNewSlotState){
            setNewSlots(slots)            
          }
          else {
            setAvailableTimeSlots(slots);
            setNewSlots(slots)  
          }
          if(newSlotSelected){
            let filteredSlots = slots.filter((each)=>each == newSelectedTime)
            if(filteredSlots.length){
              setSelectedTime(newSelectedTime);
            }
          }
          firebaseLogger.logInfo("WB_store_slot_pass", {
            response: JSON.stringify(response),
          });
        } else {
          firebaseLogger.logWarning("WB_store_slot_warn", {
            response: JSON.stringify(response),
          });
          toast.warn(response?.message);
        }
      }
    } catch (error) {
      firebaseLogger.logError("WB_store_slot_fail", {
        errorDetails: JSON.stringify(error),
      });
    } finally {
      setTimeLoading(false);
      setLoadNewSlot(false)
    }
  };

  const shouldDisableDate = (date) => {
    if (availableDates) {
      const fromDateObj = availableDates.startDate;
      const toDateObj = availableDates.endDate;
      
      if (date.isBefore(dayjs(), 'day')) {
        return true;
      }
      
      if (date.isBefore(fromDateObj, 'day') || date.isAfter(toDateObj, 'day')) {
        return true;
      }
      
      return false;
    }
    const dayOfWeek = date.format("dddd").toLowerCase();
    const formattedDate = date.format("YYYY-MM-DD");
    console.log("StoreUnAvailability", StoreUnAvailability);
    const isUnavailableDay = StoreUnAvailability.some(
      (availability) =>
        availability.DayOfTheWeek.toLowerCase() === dayOfWeek &&
        !availability.Availability
    );

    const isHoliday = StoreHolidays.includes(formattedDate);

    return isUnavailableDay || isHoliday;
  };

  const CheckValidations = () => {
    try {
      if (Title == null || Title.trim() == "") {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          title: "Title is required", // Reset error message for the field
        }));
      }
      if (
        Title != null &&
        Title.trim() == "Other" &&
        (TitleName == null || TitleName.trim() == "")
      ) {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          titleName: "TitleName is required", // Reset error message for the field
        }));
      }

      if (Firstname == null || Firstname.trim() == "") {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          firstName: "First Name is required", // Reset error message for the field
        }));
      }
      if (Lastname == null || Lastname.trim() == "") {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          lastname: "Last Name is required", // Reset error message for the field
        }));
      }
      if (Email == null || Email.trim() == "") {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          Email: "Email is required", // Reset error message for the field
        }));
      }

      if (AddressLine1 == null || AddressLine1.trim() == "") {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          addressLine1: "Address Line 1 is required", // Reset error message for the field
        }));
      }
      if (City == null || City.trim() == "") {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          City: "Town / City is required", // Reset error message for the field
        }));
      }
      if (Country == null || Country.trim() == "") {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          Country: "Country is required", // Reset error message for the field
        }));
      }

      if (PostalCode == null || PostalCode.trim() == "") {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          PostalCode: "PostCode is required", // Reset error message for the field
        }));
      }
      if (
        Mobile == null ||
        Mobile.trim() == "" ||
        Mobile.trim().length < (selectedCountry == "IRELAND" ? 9 : 10)
      ) {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          Mobile: "Contact Number is required", // Reset error message for the field
        }));
      }
    } catch (error) {}
  };

  // Book an appointment

  const deviceInfo = () => {
    const parser = new UAParser();
    const result = parser.getResult();

    const deviceType = result.device.type || "Unknown Device";
    const deviceModel = result.device.model || "Unknown Model";
    const osName = result.os.name || "Unknown OS";
    const osVersion = result.os.version || "Unknown Version";

    const deviceName = `${deviceType} ${deviceModel}`;

    return {
      deviceName: deviceName.trim(),
      deviceOS: `${osName} ${osVersion}`,
    };
  };

  const doubleEscapeJsonString = (obj) => {
    let jsonString = JSON.stringify(obj);

    jsonString = jsonString.replace(/\\/g, "\\\\").replace(/"/g, '\\"');

    jsonString = jsonString.replace(/\\/g, "\\\\").replace(/"/g, '\\"');

    return jsonString;
  };

  const upsertUser = async (cusId) => {
    try {
      let sourceAttribute = await deviceInfo();
      sourceAttribute.storeId = SelectedStore.Id ?? 0
      sourceAttribute.storeLocation = SelectedStore.Location ?? "";
      sourceAttribute.storeCode = SelectedStore.StoreCode ?? "" 
      sourceAttribute.storeName = SelectedStore.StoreName ?? ""   
      var userData = {
        customerDetails: {
          accountId:  cusId?.accountId || "",
          CustomerID: cusId?.snowflakeId || 0,
          title: Title == "Other" ? TitleName : Title,
          firstName: Firstname,
          lastName: Lastname,
          DOB: Dob != null ? dayjs(Dob).format("YYYY-MM-DD") : cusId?.DOB ? dayjs(cusId?.DOB).format("YYYY-MM-DD") : null,
          email: Email,
          countryCode: cusId?.countryCode || "N.A",
          mobileNumber: Mobile,
          phoneNumber: cusId?.phoneNumber || cusId?.Phone || 0,
          address1: AddressLine1,
          address2: AddressLine2,
          address3: AddressLine3,
          City: City,
          state: "",
          country: selectedCountry == "OTHERS" ? Country : selectedCountry,
          postalCode: PostalCode,
          brandStackID: cusId?.brandStakId ? cusId?.brandStakId : SearchCusId != null ? SearchCusId?.brandStakId : null,
          Password: "Qwerty123!",
          isEmail: EmailAlert,
          isMail: MailAlert,
          isPhone: TeleAlert,
          isSMS: SmsAlert,
          integratedBy: 0,
          experianValidateStatus: null,
          isEmployee: cusId?.isEmployee || false,
          employeeId: cusId?.employeeId || "",
          Source: (cusId?.Source == "BS" ? "WebBooking" : (cusId?.Source || "WebBooking")),
          sourceAttribute: cusId?.snowflakeId ? null : doubleEscapeJsonString(sourceAttribute),
        },
        clubCard: [],
      };

      const upsert = await UpsertCustomer(userData);
      if (upsert?.returnData?.Success == true) {
        if(!cusId?.accountId && !cusId?.snowflakeId){
          const upsertCommerce = await upsertCT()
          if(upsertCommerce == false) {
            return
          }
          setUserId(upsert?.returnData.CustomerId);
          firebaseLogger.logInfo("WB_cust_upsert_pass", {
            response: JSON.stringify(upsert),
          });
        }
      } else {
        firebaseLogger.logWarning("WB_cust_upsert_warn", {
          response: JSON.stringify(upsert),
        });
        toast.warn(
          upsert?.returnData?.Message ||
            upsert?.message ||
            "Something went wrong"
        );
      }
      return upsert;
    } catch (error) {
      firebaseLogger.logError("WB_cust_upsert_fail", {
        errorDetails: JSON.stringify(error),
      });
      toast.warn("Something went wrong");
      console.log(error);
    }
  };

  const getCustomerId = async () => {
    try {
      const customerID = await SearchCustomer(Email.trim());

      if (
        customerID?.customerSearchResult?.Success == true &&
        customerID?.customerSearchResult?.totalSize > 0
      ) {
        firebaseLogger.logInfo("WB_cust_search_pass", {
          response: JSON.stringify(customerID),
        });
        setSearchCusId(customerID?.customerSearchResult?.customerDetails[0]);
        return customerID?.customerSearchResult?.customerDetails[0];
      } else {
        setSearchCusId(null);
        return null;
      }
    } catch (error) {
      firebaseLogger.logError("WB_cust_search_fail", {
        errorDetails: JSON.stringify(error),
      });
      return null;
    }
  };

  const BookKnowUserAppointment = async (cusData) => {
    try {
      var cusId = cusData ?? null;
      if (cusId == null || cusId?.snowflakeId < 1) {
        cusId = await getCustomerId(Email);
      }

      if (
        (cusId != null && cusId?.snowflakeId > 0) ||
        (SearchCusId != null && SearchCusId?.snowflakeId > 0)
      ) {
        var data = {
          appointmentDetails: {
            serviceTypeId: SelectedSubService.serviceTypeId,
            serviceSubTypeId: SelectedSubService.SubServiceTypeId,
            expertId: 0,
            customerId:
              cusId != null ? cusId?.snowflakeId : SearchCusId?.snowflakeId,
            storeId: SelectedStore?.Id,
            appointmentDate: SelectedDate.format("YYYY-MM-DD"),
            appointmentFromTime: SelectedTime.split("-")[0],
            appointmentoTime: SelectedTime.split("-")[1],
            appointmentType: "Custom Fit",
            appointmentStatus: "Booked",
            source: "WebBooking",
          },
        };

        var resposne = await createKnownCustomerAppointment(data);
        if (resposne?.result?.returnData?.Success === true) {
          setAppointmentConfirmed(true);
          setAppointmentcode(resposne.result.returnData.AppointmentCode);
          firebaseLogger.logInfo("WB_appt_create_pass", {
            resposne: JSON.stringify(resposne),
          });
        } else {
          firebaseLogger.logWarning("WB_appt_create_warn", {
            resposne: JSON.stringify(resposne),
          });
          setAppointmentConfirmed(false);
          toast.warn(resposne?.returnData?.Message);
        }
      } else {
        setDatasubmit(false);
      }
    } catch (error) {
      firebaseLogger.logError("WB_appt_create_fail", {
        errorDetails: JSON.stringify(error),
      });
      toast.warn("Something went wrong");
    } finally {
      setDatasubmit(false);
    }
  };

  const verifyPhoneNumber = async (payload) => {
    try {
      if(validatePhone == false){
        setverifyphone(true);
        return true;
      }
      setVerifyphoneLoad(true);
      let response = await getExperianPhoneValid(payload);
      setVerifyphoneLoad(false);
      firebaseLogger.logInfo("WB_exp_phone_pass", {
        response: JSON.stringify(response),
      });
      if (response?.result?.confidence == "Verified") {
        setverifyphone(true);
        return true;
      } else {
        setErrorList((prevErrors) => ({
          ...prevErrors,
          Mobile: "unrechable number",
        }));
        setverifyphone(false);
        return false;
      }
    } catch (e) {
      firebaseLogger.logError("WB_exp_phone_fail", {
        errorDetails: JSON.stringify(e),
      });
      setVerifyphoneLoad(false);
      setverifyphone(false);
      setErrorList((prevErrors) => ({
        ...prevErrors,
        Mobile: "Contact Number is invalid",
      }));
      return false;
    }
  };

  const [emailProceed, setEmailProceed] = useState(false);
  const [phoneProceed, setPhoneProceed] = useState(false);

  const upsertCT = async ()=>{
    try {
      const payloadCommerce = {
        firstName: Firstname,
        lastName: Lastname,
        email: Email,
        password: "Qwerty123",
        streetName: AddressLine1,
        additionalAddressInfo: AddressLine2 + ',' + AddressLine3,
        city: City,
        country: selectedCountry == "OTHERS" ? Country : selectedCountry,
        state: "",
        postalCode: PostalCode,
        phone: Mobile,
        agCardNumber: "",
        birthday: Dob ? Dob?.format("YYYY-MM-DD") : "",
        title: Title.trim() == "Other" ? TitleName :  (Title || ""),
        isEmailSubscribed: EmailAlert ?? false,
        isMailSubscribed: MailAlert ?? false,
        isPhoneSubscribed: TeleAlert ?? false,
        isSMSSubscribed: SmsAlert ?? false,
      };
      const checkCustomerResonse = await CheckCustomerDataCommerceTool({email: Email ?? ""})
      if(!checkCustomerResonse?.isCustomerExistInCT){
        const responseCommerce = await AddCustomerDataCommerceTool(
          payloadCommerce
        );
        firebaseLogger.logInfo("WB_ct_createcustomer_pass", {
          response: JSON.stringify(responseCommerce),
        });
        if (responseCommerce.message || !responseCommerce?.accountId) {
          toast.warn(responseCommerce.message);
          return false
        }
      }
      return true
    }
    catch(e){
      return false
      firebaseLogger.logError("WB_ct_createcustomer_fail", {
        errorDetails: JSON.stringify(e),
      });
      toast.warn("Something went wrong");
    }
  }

  const sendRequest = async () => {
    if (!log() || !captchaValue || verifyLoad || verifyphoneLoad) {
      if(!captchaValue){
        setCaptchaError("Please Validate Captcha!")
      }
      CheckValidations();
      return;
    }
    setCaptchaError(false)
    setEmailProceed(false);
    setPhoneProceed(false);
    let emailValid = false;
    let phoneValid = false;
    if(validateEmail == false){
      emailValid = true
    }
    else {
      emailValid = await validateEmaildata({
        email: Email,
        NeedMetadata: false,
      });
    }
    if (selectedCountry != "OTHERS") {
      let countrycode = getcountryByName(countryConfig?.countryName) ?? "";
      let obj = {
        number: countrycode + Mobile,
        output_format: countryConfig?.countryIso,
        NeedMetadata: true,
      };
      if (emailValid) {
        if (verifyphone) {
          phoneValid = true;
        } else {
          phoneValid = await verifyPhoneNumber(obj);
        }
      }
    } else {
      phoneValid = true;
    }
    setEmailProceed(emailValid);
    setPhoneProceed(phoneValid);
    if (!emailValid || !phoneValid) {
      setSaveWarning(true);
      return;
    }
    try {
      setDatasubmit(true);
      setAppointmentcode("");
      let cusId = await getCustomerId();
      console.log(SearchCusId);
      // if (cusId == null || cusId?.snowflakeId < 1) {
        var upsert = await upsertUser(cusId);
        if (
          (upsert?.returnData?.Success == false &&
            upsert?.returnData?.StatusCode == 500) ||
          (upsert?.isSuccess == false && upsert?.statusCode == 500)
        ) {
          setDatasubmit(false);
          return;
        } else {
          let obj = {
            snowflakeId: upsert?.returnData?.CustomerId || 0,
          };
          cusId = obj;
        }
      // }

      await BookKnowUserAppointment(cusId);
    } catch (error) {
      firebaseLogger.logError("WB_appt_book_fail", {
        errorDetails: JSON.stringify(error),
      });
      toast.warn("Something went wrong");
    }
  };

  const [captchaValue, setCaptchaValue] = useState(false);
  const [loadCaptcha, setLoadCaptcha] = useState(false)
  const [captchaError, setCaptchaError] = useState(false)
  const recaptchaRef = useRef(null);

  const onChange = async (value) => {
    setCaptchaError(false)
    if (!value) {
      setCaptchaValue(false);
      setCaptchaError("Please Try Again!")
      if(recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      return;
    }

    try {
      const isValid = await verifyCaptcha(value);
      setCaptchaValue(isValid);

      if (!isValid && recaptchaRef.current) {
        recaptchaRef.current.reset();
        setCaptchaError("Please Try Again!")
      }
    } catch (error) {
      setCaptchaValue(false);
      setCaptchaError("Please Try Again!")
      if (recaptchaRef.current) {
        recaptchaRef.current.reset(); 
      }
    }
  };

  const verifyCaptcha = async (token) => {
    try {
      setLoadCaptcha(true)
      let data = await Verify_Captcha({recaptchaToken : token});
      firebaseLogger.logError("WB_verify_captcha_pass", {
        response: JSON.stringify(data),
      });
      setLoadCaptcha(false)
      return data?.result || false;
    } catch (error) {
      setLoadCaptcha(false)
      firebaseLogger.logError("WB_verify_captcha_fail", {
        errorDetails: JSON.stringify(error),
      });
      return false;
    }
  };

  const [emailError, setEmailError] = useState("");
  const [verifyemail, setverifyemail] = useState(false);
  const [verifyphone, setverifyphone] = useState(null);
  const [verifyphoneLoad, setVerifyphoneLoad] = useState(false);
  const [verifyLoad, setVerifyLoad] = useState(false);
  const [verifyAddress, setVerifyAddress] = useState(false);

  const validateEmaildata = async (data) => {
    let isValid = isValidEmail(Email);
    if (!isValid) {
      setEmailError("Please enter a valid email");
      return false;
    }
    return true;
    setVerifyLoad(true);
    try {
      const response = await ValidateEmail_Experian(data);
      firebaseLogger.logInfo("WB_exp_email_pass", {
        response: JSON.stringify(response),
      });
      if (response?.result?.confidence == "verified") {
        setverifyemail(true);
        setVerifyLoad(false);
        return true;
      } else if (
        response?.result?.confidence == response?.result?.verbose_output
      ) {
        // setEmailError(response?.result?.verbose_output);
        setverifyemail(false);
        setVerifyLoad(false);
        return false;
      } else {
        // setEmailError(response?.result?.verbose_output);
        const emailId = response?.result?.confidence;
        const verboseOutput = response?.result?.verbose_output;

        const emailIdFirstWordUppercase =
          emailId.charAt(0).toUpperCase() + emailId.slice(1);

        const verboseOutputWithSpaces = verboseOutput.replace(
          /([a-z])([A-Z])/g,
          "$1 $2"
        );

        const verboseOutputFormatted =
          verboseOutputWithSpaces.charAt(0).toUpperCase() +
          verboseOutputWithSpaces.slice(1).toLowerCase();

        // setEmailError(
        //   `${emailIdFirstWordUppercase} - ${verboseOutputFormatted}`
        // );

        setverifyemail(false);
        setVerifyLoad(false);
        return false;
      }
    } catch (error) {
      firebaseLogger.logError("WB_exp_email_fail", {
        errorDetails: JSON.stringify(error),
      });
      setVerifyLoad(false);
      return false;
      throw new Error(error.message);
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const [selectedCountry, setSelectedCountry] = useState("UNITED KINGDOM");
  const [countryList, setCountryList] = useState([]);
  const [countryConfig, setCountryConfig] = useState(null);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getCountryConfig();
  }, []);

  const [validateEmail , setValidateEmail] = useState(false);
  const [validatePhone, setValidatePhone] = useState(false);
  const [validateAddress, setValidateAddress] = useState(false)

  const getCountryConfig = async () => {
    try {
      let response = await getExperianConfig()
      let data = JSON.parse(response.result ?? {})
      // let data = experianConfig();
      setValidateEmail(data.experianEmailValidation || false)
      setValidatePhone(data.experianPhoneValidation || false)
      setValidateAddress(data.experianAddressValidation || false)
      let countryData = data?.DATA ?? [];
      countryData.push({ countryName: "OTHERS" });
      setCountryList(countryData);
      if (countryConfig == null) {
        findCountryConfig(selectedCountry, data?.DATA ?? []);
      }
      firebaseLogger.logInfo("WB_exp_config_pass", {
        response: JSON.stringify(data),
      });
    } catch (e) {
      firebaseLogger.logError("WB_exp_config_fail", {
        errorDetails: JSON.stringify(e),
      });
      setCountryList([]);
      setCountryConfig(null);
    }
  };

  const findCountryConfig = (name, list) => {
    let cList = list || countryList;
    let data = cList.filter(
      (each) => each.countryName.toLowerCase() == name.toLowerCase()
    );
    if (data.length) {
      setCountryConfig(data[0]);
      setSelectedCountry(data[0].countryName);
    } else {
      setSelectedCountry("OTHERS");
      // data = cList.filter((each: any) => each.countryName == "UNITED KINGDOM");
      // if (data.length) {
      //   setCountryConfig(data[0]);
      //   setSelectedCountry("UNITED KINGDOM")
      // }
    }
  };

  const searchAddressByKeyWords = async (keyword) => {
    if(validateAddress == false){
      setVerifyAddress(true);
      return
    }
    if (prefillAddress) {
      setTimeout(() => {
        setPrefillAddress(false)
      }, 2000)
      return
    }
    try {
      if (selectedCountry == "OTHERS") {
        return;
      }
      if (countryConfig == null) {
        return;
      }
      let payload = {
        country_iso: countryConfig?.countryIso,
        datasets: [],
        max_suggestions: countryConfig?.maxSuggestion,
        components: {
          unspecified: keyword,
        },
      };
      const response = await searchAddressByKeyWord(payload);
      if (response?.result?.suggestions) {
        setOptions(response?.result?.suggestions);
      } else {
        setOptions([]);
      }
      firebaseLogger.logInfo("WB_addr_opts_pass", {
        response: JSON.stringify(response),
      });
    } catch (error) {
      firebaseLogger.logError("WB_addr_opts_fail", {
        errorDetails: JSON.stringify(error),
      });
    }
  };
  const [prefillAddress, setPrefillAddress] = useState(false)
  const handleClick = async (key) => {
    setPrefillAddress(true)
    setVerifyAddress(true);
    try {
      const response = await getIndvidual_Experian({
        globalAddressKey: key,
      });
      setAddressLine1(response?.result?.address?.address_line_1);
      setAddressLine2(response?.result?.address?.address_line_2);
      setAddressLine3(response?.result?.address?.address_line_3);
      setCity(response?.result?.address?.locality || response?.result?.address?.region);
      setPostalCode(response?.result?.address?.postal_code);
      deleteError(undefined, "City");
      deleteError(undefined, "PostalCode");
      deleteError(undefined, "addressLine1");
      // setCustomerData((prevData) => ({
      //   ...prevData,
      //   addCustomer: {
      //     ...prevData.addCustomer,
      //     address1: response?.result?.address?.address_line_1,
      //     address2: response?.result?.address?.address_line_2,
      //     address3: response?.result?.address?.address_line_3,
      //     city: response?.result?.address?.locality,
      //     state: response?.result?.address?.region,
      //     country: response?.result?.address?.country,
      //     zipCode: response?.result?.address?.postal_code,
      //   },
      // }));
      firebaseLogger.logInfo("WB_addr_indiv_pass", {
        response: JSON.stringify(response),
      });
    } catch (error) {
      setPrefillAddress(false)
      firebaseLogger.logError("WB_addr_indiv_fail", {
        errorDetails: JSON.stringify(error),
      });
      throw new Error(error.message);
    }
  };

  const [debouncedAddress] = useDebounce(AddressLine1, 500);
  const [debouncedPostcode] = useDebounce(PostalCode, 500);

  useEffect(() => {
    if (debouncedAddress == "") {
      setOptions([]);
      return undefined;
    } else {
      searchAddressByKeyWords([debouncedAddress]);
    }
  }, [debouncedAddress, countryList]);

  useEffect(() => {
    if (debouncedPostcode == "") {
      setOptions([]);
      return undefined;
    } else {
      searchAddressByKeyWords([debouncedPostcode]);
    }
  }, [debouncedPostcode, countryList]);

  const log = () => {
    console.log("cc Title:", Title);
    console.log("cc Title: != ", Title.trim() != "");
    console.log("cc TitleName:", TitleName);
    console.log("cc TitleName: !=", TitleName.trim() != "");
    console.log("cc Firstname:", Firstname);
    console.log("cc Firstname: !=", Firstname.trim() != "");
    console.log("cc Lastname:", Lastname);
    console.log("cc Lastname: !=", Lastname.trim() != "");
    console.log("cc Email:", Email);
    console.log("cc AddressLine1:", AddressLine1);
    console.log("cc City:", City);
    console.log("cc selectedCountry:", selectedCountry);
    console.log("cc Country:", Country);
    console.log("cc PostalCode:", PostalCode);
    console.log("cc Mobile:", Mobile);
    console.log("cc SelectedStore:", SelectedStore);
    console.log("cc SelectedSubService:", SelectedSubService);
    console.log("cc SelectedDate:", SelectedDate);
    console.log("cc SelectedTime:", SelectedTime);
    console.log("cc verifyAddress:", verifyAddress);
    console.log("cc verifyemail:", verifyemail);

    const checkSubmitBtn =
      Title != null &&
      Title.trim().length > 0 &&
      (Title.trim() == "Other"
        ? TitleName != null && TitleName.trim().length > 0
        : true) &&
      Firstname != null &&
      Firstname.trim().length > 0 &&
      Lastname != null &&
      Lastname.trim().length > 0 &&
      Email != null &&
      Email.trim().length > 0 &&
      isValidEmail(Email) &&
      AddressLine1 != null &&
      AddressLine1.trim().length > 0 &&
      City != null &&
      City.trim().length > 0 &&
      (selectedCountry == "OTHERS"
        ? Country != null && Country.trim().length > 0
        : true) &&
      PostalCode != null &&
      PostalCode.trim().length > 0 &&
      Mobile != null &&
      Mobile.trim().length > (selectedCountry == "IRELAND" ? 8 : 9) &&
      SelectedStore != null &&
      SelectedSubService != null &&
      SelectedDate != null &&
      SelectedTime != null &&
      SelectedTime.trim().length > 0 &&
      (validateAddress ? verifyAddress === true : true);
    // verifyemail === true;
    return checkSubmitBtn;
    
  };

  let [secretKey, setSecretKey] = useState(process.env.REACT_APP_CAPTCHA_KEY);
  const [open, setOpen] = useState({});

  const handleOpen = (id) => {
    console.log("handleOpen triggered for:", id);
    setOpen((prevOpen) => {
      const newState = { ...prevOpen, [id]: true };
      console.log("New State after Open:", newState);
      return newState;
    });
  };

  const handleClose = (id) => {
    console.log("handleClose triggered for:", id);
    setOpen((prevOpen) => {
      const newState = { ...prevOpen, [id]: false };
      console.log("New State after Close:", newState);
      return newState;
    });
  };

  useEffect(() => {
    console.log("Updated open state:", open);
    const activeKeys = Object.keys(open).filter((key) => open[key]);
    setTimeout(() => {
      if (activeKeys.length > 1) {
        activeKeys.forEach((key) => {
          const element = document.getElementById(key);
          console.log("Elements ", element);
          if (element) {
            element.focus();
            console.log(`Focus set on: ${key}`);
            element.blur();
            console.log(`Focus removed from: ${key}`);
          }
        });
      }
    }, 10);
  }, [open]);

  const deleteError = (e, errorKey) => {
    if (e == undefined || e?.target?.value?.length >= 1) {
      setErrorList((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[errorKey];
        return updatedErrors;
      });
    }
  };

  const filterOptions = createFilterOptions({
    stringify: (option) =>
      `${option.StoreName} ${option.Location} ${option.CityAddress}`.toLowerCase(),
  });

  return (
    <Container sx={{ backgroundColor: "white" }}>
      <img
        src={bannerImage}
        width={"100%"}
        style={{ filter: "grayscale(60%)" }}
      />
      {AppointmentConfirmed ? (
        <Grid
          container
          spacing={4}
          columns={12}
          sx={{
            paddingLeft: {
              xs: 1, // for extra-small screens
              sm: 2, // for small screens
              md: 10, // for medium screens
            },
            paddingRight: {
              xs: 1, // for extra-small screens
              sm: 2, // for small screens
              md: 10, // for medium screens
            },
          }}
        >
          <Grid item xs={12}>
            <Typography
              Typography
              variant="h2"
              color="rgb(178, 0, 33)"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                marginTop: "20px",
              }}
            >
              Appointment Booked
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ color: "#555" }}>
              Thank you{" "}
              <Typography
                variant="subtitle1"
                display={"inline"}
                sx={{ fontWeight: "bold", color: "rgb(178, 0, 33)" }}
              >
                {Firstname}
                {", "}
              </Typography>{" "}
              Your{" "}
              <Typography
                variant="subtitle1"
                display={"inline"}
                sx={{ fontWeight: "bold", color: "rgb(178, 0, 33)" }}
              >
                {SelectedSubService?.ServiceName}{" "}
              </Typography>
              appointment at{" "}
              <Typography
                variant="subtitle1"
                display={"inline"}
                sx={{ fontWeight: "bold", color: "rgb(178, 0, 33)" }}
              >
                {SelectedStore?.StoreName}{" "}
              </Typography>{" "}
              has been successfully booked.{" "}
              <Typography
                variant="subtitle1"
                display={"inline"}
                sx={{ color: "#555" }}
              >
                We've sent a confirmation email with all the details.
              </Typography>
            </Typography>
          </Grid>

          {/* <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ color: "#555" }}>
              We've sent a confirmation email with all the details.
            </Typography>
          </Grid> */}
          {/* 
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "#555" }}
            >
              Thank you {Firstname}
            </Typography>

            <Typography variant="subtitle1" sx={{ color: "#555" }}>
              Your booking is now confirmed.
            </Typography>
          </Grid> */}

          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "#555" }}
            >
              Booking reference:
            </Typography>
            <Typography variant="subtitle1" sx={{ color: "#555" }}>
              {appointmentCode}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "#555" }}
            >
              Store:
            </Typography>
            <Typography variant="subtitle1" sx={{ color: "#555" }}>
              {SelectedStore?.StoreName}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "#555" }}
            >
              Appointment:
            </Typography>
            <Typography variant="subtitle1" sx={{ color: "#555" }}>
              {SelectedSubService.ServiceName} /{" "}
              {SelectedSubService.SubServiceName} at {SelectedStore?.StoreName}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", color: "#555" }}
            >
              Date/Time:
            </Typography>
            <Typography variant="subtitle1" sx={{ color: "#555" }}>
              {SelectedDate && SelectedDate.format("DD-MMM-YYYY")} /{" "}
              {SelectedTime} ({SelectedSubService.Duration} Minutes)
            </Typography>
          </Grid>

          <Grid item xs={12} marginTop={10}>
            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#555" }}>
              We look forward to seeing you soon in store
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={4} sx={{ paddingX: "30px", marginTop: "1%" }}>
          <Grid item xs={12} md={6}>
            {/* <Grid
              item
              sx={{
                backgroundColor: "rgb(178, 0, 33)",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                paddingY: "10px",
                textAlign: "center",
              }}
            >
              <Typography variant="h3" color={"white"}>
                Booking Information (Step-2)
              </Typography>
            </Grid> */}
            <Paper
              elevation={3}
              style={{
                padding: 15,
                borderBottomRightRadius: "10px",
                borderBottomLeftRadius: "10px",
                boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 4px",
                border: "0px",
              }}
            >
              <legend
                style={{
                  fontWeight: "bold",
                  fontFamily: "Source Sans Pro, sans-serif",
                  fontSize: "20px",
                  lineHeight: 1.235,
                  marginTop: "-30px",
                }}
              >
                <span
                  style={{
                    backgroundColor: "white",
                    color: "rgb(178, 0, 33)",
                  }}
                >
                  Booking Information (Step-1)
                </span>
              </legend>
              <Grid item sx={{ marginTop: "30px" }}>
                <Autocomplete
                  disablePortal
                  id="StoreDropdown"
                  value={SelectedStore}
                  getOptionLabel={(option) => option?.StoreName}
                  onChange={(event, newValue) => {
                    setSelectedStore(newValue);
                    setNewSelectedStore(newValue);
                    setSelectedSubService(null);
                    setSelectedTime("");
                    setNewSelectedTime("");
                    setServiceList([])
                    getServiceData(newValue.Id)
                  }}
                  disabled={TImeLoading}
                  options={storeList}
                  filterOptions={filterOptions}
                  renderInput={(params) => (
                    <TextField {...params} label="Search a store" />
                  )}
                  // renderOption={(props, option) => (
                  //   <li {...props} key={option.Id}>
                  //     {option.StoreName}
                  //   </li>
                  // )}
                  renderOption={(props, option) => (
                    <li {...props} key={option.Id} style={{ width: "100%" }}>
                      <Box sx={{ display: "block", width: "100%", my:0.75 }}>
                        <Typography 
                          variant="subtitle1" 
                          fontWeight="medium" 
                          sx={{ display: "block", lineHeight: 1.4 }}
                        >
                          {option.StoreName}
                        </Typography>
                        <Typography 
                          variant="body2" 
                          color="text.disabled" 
                          sx={{ display: "block", lineHeight: 1.3, mt:0.5 }}
                        >
                          {option.Location}
                        </Typography>
                        <Typography 
                          variant="body2" 
                          color="text.disabled" 
                          sx={{ display: "block", lineHeight: 1.3 }}
                        >
                          {option.CityAddress}
                        </Typography>
                      </Box>
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) =>
                    option.Id === value.Id
                  }
                  // getOptionDisabled={(option) => !option.Status}
                />
              </Grid>
              {true && (
                <Grid item sx={{ marginTop: "30px" }}>
                  <Autocomplete
                    getOptionLabel={(option) =>
                      `${option.ServiceName} / ${option.SubServiceName}`
                    }
                    disabled={TImeLoading || !SelectedStore || loadService}
                    value={SelectedSubService}
                    onChange={(event, newValue) => {
                      console.log("service select", newValue);
                      setSelectedSubService(newValue);
                      if(newValue.displayStartDate && newValue.displayEndDate){
                        const startDate = dayjs(newValue.displayStartDate);
                        const endDate = dayjs(newValue.displayEndDate);
                        const today = dayjs();
                        
                        setAvailableDates(() => {
                          return {
                            startDate: startDate,
                            endDate: endDate
                          }
                        })
                        
                        if (startDate.isBefore(today, 'day')) {
                          setSelectedDate(today);
                        } else {
                          setSelectedDate(startDate);
                        }
                      }
                      else {
                        setAvailableDates(null)
                        setSelectedDate(dayjs());
                      }
                      setSelectedTime("");
                      setNewSelectedTime("");
                    }}
                    id="ServiceDropdown"
                    options={ServiceList.sort(
                      (a, b) => -a.ServiceName.localeCompare(b.ServiceName)
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Search a service"
                        helperText={
                          SelectedSubService
                            ? `The duration of the selected service is ${SelectedSubService.Duration} minutes`
                            : null
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loadService && <CircularProgress sx={{mr:5}} size={20} />}
                              {params.InputProps.endAdornment}
                            </>
                          )
                        }}
                      />
                    )}
                    renderOption={(props, option) => (
                      <li {...props} key={option.SubServiceTypeId}>
                        {option.SubServiceName}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.SubServiceTypeId === value.SubServiceTypeId
                    }
                    groupBy={(option) => option.ServiceName}
                  />
                </Grid>
              )}

              {SelectedStore && SelectedSubService ? (
                <Grid
                  item
                  sx={{
                    marginTop: "30px",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <StaticDatePicker
                      defaultValue={availableDates ? availableDates.startDate : dayjs()}
                      minDate={availableDates ? availableDates.startDate : dayjs()}
                      maxDate={availableDates ? availableDates.endDate : dayjs().add(6, "months")}
                      displayStaticWrapperAs="desktop"
                      value={SelectedDate || null}
                      onChange={(newValue) => setSelectedDate(newValue)}
                      shouldDisableDate={shouldDisableDate}
                    />
                  </LocalizationProvider>
                </Grid>
              ) : (
                <>
                  <Grid
                    item
                    sx={{
                      marginTop: "30px",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <StaticDatePicker
                        defaultValue={null}
                        defaultHighlight
                        minDate={dayjs()}
                        maxDate={dayjs()}
                        displayStaticWrapperAs="desktop"
                        value={null}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        shouldDisableDate={() => true}
                        componentsProps={{
                          day: {
                            sx: {
                              "&.Mui-selected": {
                                backgroundColor: "transparent",
                              },
                              "&.MuiPickersDay-today": {
                                border: "none",
                              },
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Typography
                    sx={{ fontSize: "11px", opacity: "0.7", ml: 3, mt: 0 }}
                  >
                    {`Please select ${
                      !SelectedStore ? "store and service" : "service"
                    }`}
                  </Typography>
                </>
              )}

              {SelectedStore && SelectedSubService && SelectedDate && (
                <Grid item sx={{ marginTop: "10px" }}>
                  <Typography variant="h4">Available time slots</Typography>

                  {SelectedDate && TImeLoading && (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        color={"primary"}
                        sx={{ marginTop: "5px" }}
                      >
                        Getting the available time slots{" "}
                      </Typography>
                      <CircularProgress
                        color="primary"
                        size={"20px"}
                        sx={{ mt: 0, ml: 1 }}
                      />
                    </Box>
                  )}

                  {!TImeLoading &&
                    SelectedDate &&
                    AvailableTimeslot.length < 1 && (
                      <Typography
                        variant="subtitle2"
                        color={"primary"}
                        sx={{ marginTop: "5px" }}
                      >
                        No slots available
                      </Typography>
                    )}
                  <Stack
                    direction="row"
                    spacing={0}
                    sx={{
                      flexWrap: "wrap",
                      gap: 2,
                      marginTop: "20px",
                    }}
                  >
                    {SelectedDate &&
                      AvailableTimeslot.map((item, index) => (
                        <Chip
                          key={index}
                          label={item}
                          variant="filled"
                          clickable={true}
                          disabled={item.isEnable < 1}
                          onClick={() => {
                            setSelectedTime(item);
                            setNewSelectedTime(item);
                            // CheckValidations();
                          }}
                          color={SelectedTime == item ? "primary" : "default"}
                        />
                      ))}
                  </Stack>
                  {true && !TImeLoading && (
                    <Box>
                      <Typography
                        sx={{ fontSize: "14px", opacity: "1", ml: 1, mt: 3 }}
                      >
                        Expected Slots not available? <br></br>{" "}
                        <Typography sx={{ fontSize: "14px", mt: 0.2 }}>
                          Please select different date or{" "}
                          <span
                            onClick={() => {
                              setOpenMap(true);
                              setNewSelectedStore(SelectedStore);
                              setNewSelectedTime(SelectedTime);
                              setNewSlots(AvailableTimeslot);
                              // getTimeSlots(setNewSlots, SelectedStore.Id);
                            }}
                            style={{
                              fontSize: "14px",
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "#B20021",
                            }}
                          >
                            Find NearBy Store{" "}
                            <LocationOnIcon
                              sx={{
                                position: "relative",
                                right: "5px",
                                top: "5px",
                              }}
                            />
                          </span>{" "}
                          <span
                            style={{
                              position: "relative",
                              right: "10px",
                              fontSize: "11px",
                            }}
                          >
                            (100 Miles)
                          </span>
                        </Typography>
                      </Typography>
                    </Box>
                  )}
                </Grid>
              )}
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            {/* <Grid
              item
              sx={{
                backgroundColor: "rgb(178, 0, 33)",
                borderTopLeftRadius: "10px",
                borderTopRightRadius: "10px",
                paddingY: "10px",
                textAlign: "center",
              }}
            >
              <Typography variant="h3" color={"white"}>
                Contact Information (Step-1)
              </Typography>
            </Grid> */}
            <Paper
              elevation={3}
              style={{
                padding: 15,
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                boxShadow: "rgba(0, 0, 0, 0.3) 0px 0px 4px",
                border: "0px",
                paddingTop: "25px",
              }}
            >
              <legend
                style={{
                  fontWeight: "bold",
                  fontFamily: "Source Sans Pro, sans-serif",
                  fontSize: "20px",
                  lineHeight: 1.235,
                  marginTop: "-40px",
                }}
              >
                <span
                  style={{
                    backgroundColor: "white",
                    color: "rgb(178, 0, 33)",
                  }}
                >
                  Contact Information (Step-2)
                </span>
              </legend>
              <Grid item marginTop={"20px"}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FormControl
                    sx={{ width: "25%", mr: 1 }}
                    error={
                      ErrorList?.title && ErrorList?.title.length > 1
                        ? true
                        : false
                    }
                  >
                    <InputLabel id="demo-simple-select-label">
                      Title{" "}
                      <Typography component="span" sx={{ color: "#B20021" }}>
                        *
                      </Typography>
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={Title}
                      label="Select"
                      onChange={(e) => {
                        setTitle(e.target.value);
                      }}
                      onBlur={(e) => deleteError(e, "title")}
                    >
                      <MenuItem value={"Mr"}>Mr</MenuItem>
                      <MenuItem value={"Mrs"}>Mrs</MenuItem>
                      <MenuItem value={"Ms"}>Ms</MenuItem>
                      <MenuItem value={"Miss"}>Miss</MenuItem>
                      <MenuItem value={"Other"}>Other</MenuItem>
                    </Select>
                  </FormControl>
                  {Title == "Other" ? (
                    <TextField
                      value={TitleName}
                      onChange={(e) => {
                        setTitleName(e.target.value);
                      }}
                      sx={{ width: "74%", my: 1 }}
                      id="outlined-basic"
                      error={ErrorList?.titleName ? true : false}
                      label={
                        <>
                          Title Name <span style={{ color: "#B20021" }}>*</span>
                        </>
                      }
                      variant="outlined"
                      onBlur={(e) => deleteError(e, "titleName")}
                      InputProps={{
                        endAdornment: TitleName?.length > 0 && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setTitleName("")}
                            >
                              <Clear />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  ) : (
                    <TextField
                      value={Firstname}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                      sx={{ width: "74%", my: 1 }}
                      id="outlined-basic"
                      label={
                        <>
                          First Name <span style={{ color: "#B20021" }}>*</span>
                        </>
                      }
                      autoComplete="off"
                      variant="outlined"
                      error={ErrorList?.firstName ? true : false}
                      onBlur={(e) => deleteError(e, "firstName")}
                      InputProps={{
                        endAdornment: Firstname?.length > 0 && (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setFirstName("")}
                            >
                              <Clear />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </Box>
              </Grid>
              {Title == "Other" && (
                <Grid item style={{ marginTop: "15px" }}>
                  <TextField
                    value={Firstname}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                    }}
                    fullWidth
                    id="outlined-basic"
                    label={
                      <>
                        First Name <span style={{ color: "#B20021" }}>*</span>
                      </>
                    }
                    autoComplete="off"
                    variant="outlined"
                    error={ErrorList?.firstName ? true : false}
                    onBlur={(e) => deleteError(e, "firstName")}
                    InputProps={{
                      endAdornment: Firstname?.length > 0 && (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() => setFirstName("")}
                          >
                            <Clear />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              )}
              <Grid item style={{ marginTop: "15px" }}>
                <TextField
                  value={Lastname}
                  onChange={(e) => {
                    setlastName(e.target.value);
                  }}
                  fullWidth
                  id="outlined-basic"
                  label={
                    <>
                      Last Name <span style={{ color: "#B20021" }}>*</span>
                    </>
                  }
                  autoComplete="off"
                  variant="outlined"
                  error={ErrorList?.lastname ? true : false}
                  onBlur={(e) => deleteError(e, "lastname")}
                  InputProps={{
                    endAdornment: Lastname?.length > 0 && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={() => setlastName("")}
                        >
                          <Clear />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {Title &&
                Firstname &&
                Lastname &&
                (Title == "Other" ? TitleName : true) && (
                  <>
                    <Grid item style={{ marginTop: "15px" }}>
                      <TextField
                        value={Email}
                        onChange={(e) => {
                          setverifyemail(false);
                          setEmailError("");
                          setEmail(e.target.value);
                        }}
                        onBlur={() => {
                          let isValid = isValidEmail(Email);
                          if (!isValid) {
                            setEmailError("Please enter a valid email");
                            return;
                          } else {
                            setEmailError("");
                            deleteError(undefined, "Email");
                            validateEmaildata({
                              email: Email,
                              NeedMetadata: false,
                            });
                          }
                        }}
                        InputProps={{
                          endAdornment: false && (
                            <>
                              <InputAdornment position="end">
                                <Button
                                  sx={{
                                    color: verifyemail ? "green" : "#B20021",
                                  }}
                                  size="small"
                                  onClick={(e) => {
                                    if (verifyLoad || Datasubmit || verifyemail)
                                      return;
                                    validateEmaildata({
                                      email: Email,
                                      NeedMetadata: false,
                                    });
                                  }}
                                  startIcon={
                                    verifyemail ? (
                                      <MarkEmailReadTwoToneIcon
                                        sx={{ color: "green" }}
                                      />
                                    ) : (
                                      <EmailTwoToneIcon
                                        sx={{ color: "#B20021" }}
                                      />
                                    )
                                  }
                                >
                                  {verifyLoad ? (
                                    <CircularProgress
                                      color="inherit"
                                      size={16}
                                    />
                                  ) : verifyemail ? (
                                    "Verified"
                                  ) : (
                                    "Verify"
                                  )}
                                </Button>
                              </InputAdornment>
                            </>
                          ),
                        }}
                        helperText={emailError?.length > 0 && emailError}
                        error={emailError?.length > 0 || ErrorList?.Email}
                        autoComplete="off"
                        fullWidth
                        id="outlined-basic"
                        label={
                          <>
                            Email <span style={{ color: "#B20021" }}>*</span>
                          </>
                        }
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item style={{ marginTop: "15px" }}>
                    <TextField
                      value={Mobile}
                      autoComplete="off"
                      fullWidth
                      id="outlined-basic"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: focused || Boolean(Mobile),
                      }}
                      label={
                        <>
                          Contact Number{" "}
                          <span style={{ color: "#B20021" }}>*</span>
                        </>
                      }

                      onChange={(e) => {
                        const digitsOnly = e.target.value.replace(/\D/g, "");
                        setMobile(digitsOnly);
                        deleteError(e, "Mobile");
                        setverifyphone(false)
                      }}

                      onPaste={(e) => {
                        e.preventDefault();
                        const pastedText = e.clipboardData.getData("text");
                        const digitsOnly = pastedText.replace(/\D/g, "");
                        setMobile(digitsOnly);
                        deleteError(e, "Mobile");
                      }}

                      onFocus={() => setFocused(true)}

                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                      }}

                      error={
                        (Mobile?.trim()?.length > 0 &&
                          Mobile.trim().length <=
                            (selectedCountry === "IRELAND" ? 8 : 9)) ||
                        (ErrorList?.Mobile && ErrorList?.Mobile.length > 2)
                      }

                      helperText={
                        selectedCountry !== "OTHERS"
                          ? Mobile?.trim()?.length > 0 &&
                            Mobile.trim().length <=
                              (selectedCountry === "IRELAND" ? 8 : 9)
                            ? "Enter a valid contact number"
                            : ErrorList?.Mobile === "unrechable number"
                            ? "Enter a valid contact number"
                            : null
                          : ""
                      }

                      onBlur={(e) => {
                        setFocused(false);
                        deleteError(e, "Mobile");

                        if (
                          Mobile?.trim()?.length >=
                          (selectedCountry === "IRELAND" ? 9 : 10)
                        ) {
                          const number =
                            (getcountryByName(countryConfig?.countryName) ?? "") + Mobile;

                          if (selectedCountry !== "OTHERS") {
                            verifyPhoneNumber({
                              number,
                              output_format: countryConfig?.countryIso,
                              NeedMetadata: true,
                            });
                          } else {
                            setPhoneProceed(true);
                          }
                        }
                      }}

                      InputProps={{
                        endAdornment:
                          Mobile?.length > 0 &&
                          validatePhone === true &&
                          (verifyphone ? (
                            <Button
                              sx={{ color: "green" }}
                              size="small"
                              startIcon={
                                <SystemSecurityUpdateGoodTwoToneIcon sx={{ color: "green" }} />
                              }
                            >
                              Verified
                            </Button>
                          ) : verifyphoneLoad ? (
                            <CircularProgress sx={{ color: "#B20021" }} size={16} />
                          ) : null),
                      }}
                    />
                    </Grid>
                    <Grid item style={{ marginTop: "15px" }}>
                      <FormControl
                        sx={{ width: "100%" }}
                        variant="outlined"
                        size="medium"
                      >
                        <InputLabel id="demo-simple-select-label">
                          Country{" "}
                          <Typography
                            component="span"
                            sx={{ color: "#B20021" }}
                          >
                            *
                          </Typography>
                        </InputLabel>
                        <Select
                          labelId="Country *"
                          id="Country *"
                          label="Country *"
                          value={selectedCountry}
                          onChange={(e) => {
                            if (e.target.value == "OTHERS") {
                              setVerifyAddress(true);
                              setOptions([]);
                            } else {
                              setVerifyAddress(false);
                            }
                            setVerifyAddress(false);
                            setSelectedCountry(e.target.value);
                            findCountryConfig(e.target.value);
                            setAddressLine1("");
                            setAddressLine2("");
                            setAddressLine3("");
                            setCity("");
                            setPostalCode("");
                            findCountryConfig(e.target.value);
                          }}
                          disabled={countryList?.length == 0}
                        >
                          {countryList.map((item, index) => (
                            <MenuItem key={index} value={item.countryName}>
                              {item.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    {selectedCountry == "OTHERS" && (
                      <Grid item style={{ marginTop: "15px" }}>
                        <TextField
                          value={Country}
                          onChange={(e) => {
                            setCountry(e.target.value);
                          }}
                          fullWidth
                          id="outlined-basic"
                          label={
                            <>
                              Country Name{" "}
                              <span style={{ color: "#B20021" }}>*</span>
                            </>
                          }
                          variant="outlined"
                          autoComplete="off"
                          error={
                            ErrorList?.Country && ErrorList?.Country.length > 2
                              ? true
                              : false
                          }
                          onBlur={(e) => deleteError(e, "Country")}
                          InputProps={{
                            endAdornment: Country.length > 0 && (
                              <InputAdornment position="end">
                                <IconButton
                                  size="small"
                                  onClick={() => setCountry("")}
                                >
                                  <Clear />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item style={{ marginTop: "15px" }}>
                      <Autocomplete
                        freeSolo
                        id="zipCode"
                        onOpen={() => handleOpen("zipCode")}
                        onClose={() => handleClose("zipCode")}
                        disableClearable
                        options={options}
                        getOptionLabel={(option) => option.text}
                        filterOptions={() => options}
                        inputValue={PostalCode}
                        onInputChange={(event, newInputValue) => {
                          selectedCountry != "OTHERS"
                            ? setVerifyAddress(false)
                            : setVerifyAddress(true);
                          setPostalCode(newInputValue);
                        }}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            handleClick(newValue?.global_address_key);
                          }
                        }}
                        onBlur={(e) => {
                          deleteError(e, "PostalCode");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            id="outlined-basic"
                            label={
                              <>
                                Postcode{" "}
                                <span style={{ color: "#B20021" }}>*</span>
                              </>
                            }
                            error={ErrorList?.PostalCode ? true : false}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <InputAdornment position="end">
                                  {selectedCountry != "OTHERS" &&
                                    validateAddress == true && (
                                      <Button
                                        size="small"
                                        disabled={true}
                                        startIcon={
                                          PostalCode?.length > 0 &&
                                          (verifyAddress ? (
                                            <WhereToVoteTwoToneIcon
                                              sx={{ color: "green" }}
                                            />
                                          ) : (
                                            <LocationOffTwoTone />
                                          ))
                                        }
                                        sx={{
                                          my: 2,
                                          color: verifyAddress
                                            ? "green"
                                            : "#B20021",
                                          mr: 2,
                                          pointerEvents: "none", // Prevent interactions
                                          "&:hover": {
                                            backgroundColor: "transparent", // Prevent hover effects
                                          },
                                          "&.Mui-disabled": {
                                            color: verifyAddress
                                              ? "green"
                                              : "#B20021", // Override default disabled text color
                                          },
                                        }}
                                      >
                                        {verifyAddress
                                          ? "Verified Address"
                                          : PostalCode?.length > 0 &&
                                            "Address Not Verified"}
                                      </Button>
                                    )}
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item style={{ marginTop: "15px" }}>
                      <Autocomplete
                        freeSolo
                        id="address1"
                        //disableClearable
                        options={options}
                        onOpen={() => handleOpen("address1")}
                        onClose={() => handleClose("address1")}
                        getOptionLabel={(option) => option.text}
                        filterOptions={() => options}
                        inputValue={AddressLine1}
                        onInputChange={(event, newInputValue) => {
                          selectedCountry != "OTHERS"
                            ? setVerifyAddress(false)
                            : setVerifyAddress(true);
                          setAddressLine1(newInputValue);
                        }}
                        onChange={(event, newValue) => {
                          if (newValue && selectedCountry != "OTHERS") {
                            // removeErr("zipCode");
                            handleClick(newValue?.global_address_key);
                          }
                        }}
                        onBlur={(e) => {
                          deleteError(e, "addressLine1");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            id="outlined-basic"
                            label={
                              <>
                                Address Line 1{" "}
                                <span style={{ color: "#B20021" }}>*</span>
                              </>
                            }
                            error={ErrorList?.addressLine1 ? true : false}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item style={{ marginTop: "15px" }}>
                      <Autocomplete
                        freeSolo
                        id="address2"
                        options={options}
                        onOpen={() => handleOpen("address2")}
                        onClose={() => handleClose("address2")}
                        getOptionLabel={(option) => option.text}
                        inputValue={AddressLine2}
                        onInputChange={(event, newInputValue) => {
                          selectedCountry != "OTHERS"
                            ? setVerifyAddress(false)
                            : setVerifyAddress(true);
                          setAddressLine2(newInputValue);
                        }}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            handleClick(newValue?.global_address_key);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            id="outlined-basic"
                            label="Address Line 2"
                            error={false}
                            // required
                          />
                        )}
                      />
                    </Grid>
                    <Grid item style={{ marginTop: "15px" }}>
                      <Autocomplete
                        freeSolo
                        id="address3"
                        oonOpen={() => handleOpen("address3")}
                        onClose={() => handleClose("address2")}
                        options={options}
                        getOptionLabel={(option) => option.text}
                        inputValue={AddressLine3}
                        onInputChange={(event, newInputValue) => {
                          selectedCountry != "OTHERS"
                            ? setVerifyAddress(false)
                            : setVerifyAddress(true);
                          setAddressLine3(newInputValue);
                        }}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            handleClick(newValue?.global_address_key);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            id="outlined-basic"
                            label="Address Line 3"
                            error={false}
                            // required
                          />
                        )}
                      />
                    </Grid>
                    <Grid item style={{ marginTop: "15px" }}>
                      <Autocomplete
                        freeSolo
                        id="Town"
                        onOpen={() => handleOpen("Town")}
                        onClose={() => handleClose("Town")}
                        options={options}
                        getOptionLabel={(option) => option.text}
                        inputValue={City}
                        onInputChange={(event, newInputValue) => {
                          selectedCountry != "OTHERS"
                            ? setVerifyAddress(false)
                            : setVerifyAddress(true);
                          setCity(newInputValue);
                        }}
                        onChange={(event, newValue) => {
                          if (newValue) {
                            handleClick(newValue?.global_address_key);
                          }
                        }}
                        onBlur={(e) => {
                          deleteError(e, "City");
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            id="outlined-basic"
                            label={
                              <>
                                Town / City{" "}
                                <span style={{ color: "#B20021" }}>*</span>
                              </>
                            }
                            error={ErrorList?.City ? true : false}
                          />
                        )}
                      />
                    </Grid>
                    <Grid item style={{ marginTop: "15px" }}>
                      <LocalizationProvider
                        localeText={{
                          fieldMonthPlaceholder: (params) =>
                            params.contentType === "digit"
                              ? "MM"
                              : params.format,
                        }}
                        dateAdapter={AdapterDayjs}
                      >
                        <DatePicker
                          label="Date of Birth"
                          sx={{ width: "100%" }}
                          value={Dob}
                          onChange={(newValue) =>
                            dayjs() > newValue ? setDob(newValue) : setDob(null)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              inputProps={{ ...params.inputProps }}
                              fullWidth={true}
                            />
                          )}
                          slotProps={{
                            field: {
                              clearable: true,
                              onClear: () => setDob(null),
                            },
                            textField: { placeholder: "DD-MMM-YYYY" },
                            input: {
                              readOnly: true,
                            },
                          }}
                          maxDate={dayjs()}
                          format="DD-MMM-YYYY"
                        />
                      </LocalizationProvider>
                    </Grid>
                  </>
                )}
              <Grid item style={{ marginTop: "15px" }}>
                <Box
                  p={1}
                  sx={{ backgroundColor: "#F5F4F3", marginBottom: "10px" }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", color: "black" }}
                  >
                    Stay informed about our latest news and offers
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "GrayText",
                      marginTop: "5px",
                    }}
                  >
                    By signing up, you agree to receive marketing communications
                    from American Golf. We respect your privacy and are
                    committed to protecting your personal data.
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "GrayText",
                      marginTop: "5px",
                    }}
                  >
                    Your information will only be used to send you updates,
                    promotions, and relevant news. You can unsubscribe at any
                    time.
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "GrayText",
                      marginTop: "5px",
                    }}
                  >
                    You can choose your marketing preferences below. I would
                    like to receive up to date news, offers and promotions by;
                  </Typography>
                </Box>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", color: "#555" }}
                >
                  Marketing Consent
                </Typography>
                <Stack direction={"row"} useFlexGap sx={{ flexWrap: "wrap" }}>
                  <FormControlLabel
                    control={
                      <Switch
                        required
                        value={EmailAlert}
                        onChange={(e) => setEmailAlert(e.target.checked)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "green",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "green",
                            },
                        }}
                      />
                    }
                    label="Email"
                  />
                  <FormControlLabel
                    required
                    control={
                      <Switch
                        value={SmsAlert}
                        onChange={(e) => setSmSAlert(e.target.checked)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "green",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "green",
                            },
                        }}
                      />
                    }
                    label="SMS"
                  />
                  <FormControlLabel
                    required
                    control={
                      <Switch
                        value={TeleAlert}
                        onChange={(e) => setTeleAlert(e.target.checked)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "green",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "green",
                            },
                        }}
                      />
                    }
                    label="Telephone"
                  />
                  <FormControlLabel
                    required
                    control={
                      <Switch
                        value={MailAlert}
                        onChange={(e) => setMailAlert(e.target.checked)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "green",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                            {
                              backgroundColor: "green",
                            },
                        }}
                      />
                    }
                    label="Mail"
                  />
                </Stack>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    my: 3,
                  }}
                >
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={secretKey}
                    onChange={onChange}
                  />
                  {captchaError != false ? (
                    <Typography sx={{ color: "#B20021", fontSize: "12px" }}>
                      {captchaError}
                    </Typography>
                  ) : null}
                </Box>
                <Grid item sx={{ textAlign: "center", my: 3 }}>
                  <Button
                    variant="contained"
                    disabled={
                      loadCaptcha ||
                      verifyLoad ||
                      verifyphoneLoad ||
                      !(
                        Title &&
                        Firstname &&
                        Lastname &&
                        (Title == "Other" ? TitleName : true)
                      )
                    }
                    onClick={() => sendRequest()}
                  >
                    Book an appointment
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      )}
      <Box
        sx={{
          textAlign: "right",
          paddingY: 2,
          backgroundColor: "white",
        }}
      >
        <Divider />

        <Typography variant="subtitle1" color={"GrayText"}>
          For more details on how we manage your data, please review our &nbsp;
          <Link
            href="https://www.americangolf.co.uk/services/content/privacy-policy.html"
            variant="subtitle1"
            color={"#1B2F46"}
            sx={{ marginRight: "20px", fontWeight: "bold" }}
          >
            Privacy Policy
          </Link>
        </Typography>
      </Box>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={Datasubmit}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {saveWarning && (
        <Dialog
          fullWidth
          open={true}
          onClose={(event, reason) => {
            if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
              console.log("Closed");
            }
          }}
          disableEscapeKeyDown
        >
          <DialogTitle fontWeight={"bold"} variant="h4"></DialogTitle>
          <DialogContent>
            <Box
              sx={{
                mt: 1,
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Box>
                <WarningIcon
                  sx={{ fontSize: "72px", color: "orange" }}
                ></WarningIcon>
              </Box>

              {!emailProceed ? (
                <Typography
                  sx={{ mt: 1, fontSize: "16px", textAlign: "center" }}
                >
                  Provided email address is invalid or unreachable, no emails
                  will get triggered. Please provide valid email address to
                  receive emails.
                </Typography>
              ) : (
                <Typography
                  sx={{ mt: 1, fontSize: "16px", textAlign: "center" }}
                >
                  Provided contact number is invalid. Please provide valid
                  contact number.
                </Typography>
              )}
              {/* {<Typography sx={{ mt: 2}}>
                Do you want to proceed?
              </Typography>} */}
            </Box>
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                mb: 2,
              }}
            >
              <Button
                sx={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "5px 10px",
                  marginTop: 4,
                }}
                onClick={() => {
                  console.log("Clicked No");
                  setSaveWarning(false);
                }}
              >
                OK
              </Button>
              {/* <Button
              variant="contained"
                sx={{
                  marginTop: 4,
                  marginLeft: 5,
                  textTransform: "none !important",
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "5px 10px",
                }}
                onClick={() => {
                  setSaveWarning(false);
                  sendRequest(true)
                }}
              >
                YES
              </Button> */}
            </Box>
          </DialogActions>
        </Dialog>
      )}

      {/* Find A Store Dialog */}

      {openMap && (
          <Dialog
            open={true}
            maxWidth={false}
            onClose={(event, reason) => {
              if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                console.log("Closed");
              }
            }}
            disableEscapeKeyDown
            PaperProps={{
              sx: {
                width: { xs: "95vw", md: "60vw" },
                maxWidth: "none"
              }
            }}
          >
          <DialogTitle
            textAlign={"center"}
            justifyContent={"center"}
            fontWeight={"bold"}
            variant="h4"
          >
            Find alternate store to book an appointment on{" "}
            <strong>{SelectedDate.format("DD-MMM-YYYY")}</strong>
          </DialogTitle>

          <DialogContent>

            <Grid sx={{mt:1}} container spacing={2}>
              <Grid item xs={12} md={7.5}>
                <UKMapWithMarkers
                  locations={storeList}
                  newStore={newSelectedStore}
                  oldStore={SelectedStore}
                  setNewStore={setNewSelectedStore}
                  setNewSlots={setNewSlots}
                  SelectedSubService={SelectedSubService}
                  getTimeSlots={getTimeSlots}
                  setNewSelectedTime={setNewSelectedTime}
                />
              </Grid>

              <Grid item xs={12} md={4.5}>
                <Box sx={{mx:1}}>

                  <Box>
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: "18px",
                        color: "black",
                        mb: 1,
                        fontWeight: "600",
                      }}
                      gutterBottom
                    >
                      Available time slots
                    </Typography>
                    {loadNewSlot ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          height: "120px"
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          color={"primary"}
                          sx={{ marginTop: "5px" }}
                        >
                          Getting the available time slots{" "}
                        </Typography>
                        <CircularProgress
                          color="primary"
                          size={"20px"}
                          sx={{ mt: 0, ml: 1 }}
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          // justifyContent: "center",
                          gap: 1,
                          mt: 1,
                          minHeight: "75px",
                          maxHeight: "120px",
                          overflowY: "auto",
                          "&::-webkit-scrollbar": {
                            width: "3px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#888",
                            borderRadius: "4px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            backgroundColor: "#555",
                          },
                          "&::-webkit-scrollbar-track": {
                            backgroundColor: "#f1f1f1",
                          },
                        }}
                      >
                        {newSlots.map((item, index) => {
                          return (
                            <Chip
                              key={index}
                              label={item}
                              variant="filled"
                              clickable
                              disabled={item.isEnable < 1}
                              onClick={() => setNewSelectedTime(item)}
                              color={
                                newSelectedTime == item ? "primary" : "default"
                              }
                            />
                          );
                        })}
                        {newSlots.length < 1 && (
                          <Typography
                            variant="subtitle2"
                            color={"primary"}
                            sx={{ marginTop: "5px" }}
                          >
                            No slots available
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Box>

                  <Box sx={{ my: 4 }}>{/* <hr></hr> */}</Box>

                  <Box>
                    <Typography
                      sx={{
                        fontSize: "18px",
                        color: "black",
                        fontWeight: "600",
                      }}
                      gutterBottom
                    >
                      Selected Store And Service
                    </Typography>
                    <Box sx={{ display: "flex", mt: 0.5, alignItems: "center" }}>
                      <PlaceIcon
                        sx={{ color: SelectedStore.Id == newSelectedStore.Id  ? "#B20021" : "#EE8016", fontSize: 20, mr: 1 }}
                      />
                      <Typography sx={{color: "#B20021", fontWeight: "bold", fontSize: "16px"}}>{newSelectedStore?.StoreName}</Typography>
                    </Box>

                    <Box sx={{ display: "flex", mt: 0.2 }}>
                      <Box
                        sx={{
                          backgroundColor: "#B20021",
                          borderRadius: "50%",
                          width: 16,
                          height: 16,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mt: 0.4,
                          ml:0.2
                        }}
                      >
                        <PhoneIcon sx={{ color: "white", fontSize: 11.5 }} />
                      </Box>
                      <Typography sx={{ ml: 1.25 }}>
                        {newSelectedStore?.Phone}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", alignItems: "center", mt: 0.2 }}
                    >
                      <BuildCircleIcon
                        sx={{ color: "#B20021", fontSize: 20, mr: 1 }}
                      />
                      <Typography>{SelectedSubService?.ServiceName} / {SelectedSubService?.SubServiceName}</Typography>
                    </Box>
                  </Box>

                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Box>
                {newSelectedTime && (
                  <Typography sx={{ mx: 2 }}>
                    You have selected{" "}
                    <strong>{newSelectedStore?.StoreName}</strong> appointment
                    on <strong>{newSelectedTime}</strong> time{" "}
                    <strong>
                      <strong>{SelectedDate.format("DD-MMM-YYYY")}</strong>
                    </strong>
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  mb: 2,
                }}
              >
                <Button
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    padding: "5px 10px",
                    marginTop: 4,
                  }}
                  onClick={() => {
                    setOpenMap(false);
                    setNewSelectedStore(null);
                    setNewSelectedTime(null);
                    setNewSlots([]);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    padding: "5px 10px",
                    marginTop: 4,
                    ml: 5,
                  }}
                  onClick={() => {
                    setOpenMap(false);
                    setSelectedStore(newSelectedStore);
                    // setSelectedTime(newSelectedTime);
                    setNewSlots([]);
                    getTimeSlots(null, newSelectedStore.Id, newSelectedTime);
                  }}
                  disabled={!newSelectedTime || newSlots.length < 1}
                >
                  Select
                </Button>
              </Box>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </Container>
  );
}


